Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("../../styles");
var _reactNative = require("react-native-web");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    focused = _STYLES$useStyles.focused,
    input = _STYLES$useStyles.input,
    disabled = _STYLES$useStyles.disabled,
    spacing = _STYLES$useStyles.spacing,
    COLORS = _STYLES$useStyles.COLORS;
  var mutlilineNumberOfLines = 8;
  var _multilineHeight = _reactNative.Platform.OS === 'web' ? "\n      calc(\n        ((".concat(input.fontSize, " * 1.5) * ").concat(mutlilineNumberOfLines, ") \n        + (").concat(spacing.m, " * 2)\n      )\n    ") : input.lineHeight * mutlilineNumberOfLines + spacing.m * 2;
  var textInput_multiline = {
    height: _multilineHeight,
    overflow: 'scroll',
    paddingTop: spacing.m,
    paddingBottom: spacing.m,
    borderRadius: (0, _styles.getREM)(1),
    borderColor: COLORS.aubergine,
    borderWidth: (0, _styles.getREM)(0.125),
    backgroundColor: COLORS.white
  };
  var styles = _reactNative.StyleSheet.create({
    textInput: input,
    textInput_disabled: disabled,
    textInput_focused: focused,
    textInput_multiline: textInput_multiline
  });
  return {
    styles: styles,
    mutlilineNumberOfLines: mutlilineNumberOfLines
  };
};